import Module from '../../module';
import scroll from '../../../libs/scroll/scroll';

import sliderListCutFactory, { PublicVarsInterface as SliderListCutSetupInterface } from '../../../libs/slider/slider-list-cut';

interface OptionsInterface {
	cssId: {
		anim?: {
			aboutPrimaryHeliumStrategyContentSectionSubheaderCustomCls: string;
			aboutPrimaryHeliumStrategyContentSectionHeaderCls: string;
			aboutPrimaryHeliumStrategyContentSectionInnerCls: string;
			aboutPremiumHeliumStrategySliderCls: string;
		}
	},

	sliderListCutSetup?: SliderListCutSetupInterface

	slug: string
}

class Strategy extends Module {

	publicVars: OptionsInterface;

	constructor(options: OptionsInterface) {
		super('About Primary Helium Strategy Module');

		this.publicVars = options;
	}

	startup() {
		this.msg('startup');

		if(!this.publicVars.sliderListCutSetup) {
			this.errorMsg('sliderSetup is not defined');
		} else {
			const slider = sliderListCutFactory.create();
			slider.init(this.publicVars.sliderListCutSetup);
		}

		scroll.init();
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.aboutPrimaryHeliumStrategyContentSectionSubheaderCustomCls || '','about_primary_helium_strategy', { animCls: 'animate__zoomIn', once: true});
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.aboutPrimaryHeliumStrategyContentSectionHeaderCls || '','about_primary_helium_strategy', { animCls: 'animate__fadeInLeft25P', once: true});
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.aboutPrimaryHeliumStrategyContentSectionInnerCls || '','about_primary_helium_strategy', { animCls: 'animate__fadeInDown50P', once: true});
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.aboutPremiumHeliumStrategySliderCls || '','about_primary_helium_strategy', { animCls: 'animate__fadeInRight25P', once: true});
	}

	bind() {
		this.msg('bind');
	}
}

export default Strategy;